import { createSelector } from '@reduxjs/toolkit';
import {
  selectAvailableUserIds,
  selectLocalUser,
  selectUserEntries,
} from 'features/users/usersSlice';
import { selectPermissionsState } from 'features/permissions/permissionsSlice';
import { refinePermissions } from 'features/permissions/utils/refinePermissions';
import { PermissionTypes } from 'features/permissions/types';

// Auto-assignment excludes participants holding the Manage Breakout permission by
// design (so moderators aren't dropped into a random breakout). Mirror that filter
// here so the "users per room" preview reflects who will actually be distributed.
export const selectAutoAssignableUserIds = createSelector(
  [selectAvailableUserIds, selectUserEntries, selectLocalUser, selectPermissionsState],
  (availableIds, userEntries, localUser, permissionsState) =>
    availableIds.filter((id) => {
      const user = userEntries[id];
      if (!user) {
        return false;
      }

      return !refinePermissions(PermissionTypes.manageBreakout, {
        permissionsState,
        localUser,
        targetUser: user,
      });
    })
);
